import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=dc4c4852&"
import script from "./Quotation.vue?vue&type=script&lang=js&"
export * from "./Quotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports